// extracted by mini-css-extract-plugin
export default {"videoBlock":"BlockRenderer_videoBlock__eOA5S"};